//此文件由工具自动生成,不要手动修改此文件
//在/centralsvn/BaseCode/wpcommonEditors/OpenApiAccount.xlsm中修改并生成
//update_time[2023.1.12 15:59:47]

let openApiAccountType = {};

openApiAccountType.getData = function() {
	var data = [
		{
			value : 0,
			label : "微信公众号",
		},
		{
			value : 1,
			label : "微信小程序",
		},
		{
			value : 2,
			label : "企业微信",
		},
		{
			value : 3,
			label : "DmtOpenApi",
		},
		{
			value : 4,
			label : "DmtDataCenter",
		},
		{
			value : 5,
			label : "WebPower邮件",
		},
		{
			value : 6,
			label : "WebPower短信",
		},
		{
			value : 7,
			label : "企业微信事件回调",
		},
		{
			value : 8,
			label : "OSS",
		},
		{
			value : 9,
			label : "WPSH",
		},
		{
			value : 10,
			label : "COS",
		},
		{
			value : 11,
			label : "CONNEXT",
		},
		{
			value : 12,
			label : "ELC中台创建兑礼订单",
		},
		{
			value : 13,
			label : "ELC中台库存同步",
		},
		{
			value : 14,
			label : "腾讯位置服务",
		},
		{
			value : 15,
			label : "ELC中台创建兑礼订单",
		},
		{
			value : 16,
			label : "ELC中台查询兑礼订单",
		},
		{
			value : 17,
			label : "ELC中台实时查询库存",
		},
	];
	return data;
};

export default openApiAccountType;



// WEBPACK FOOTER //
// ./src/utils/OpenApiAccountType.js